import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  connect() {
    const inputs = this.element.querySelectorAll(".my-datepicker")

    inputs.forEach((el) => {
      if (el.dataset.pickerInitialized) return

      flatpickr(el, {
        dateFormat: "Y-m-d",
        allowInput: true,
      })

      el.dataset.pickerInitialized = "true"
    })

  }
}
